import { format } from 'date-fns';
import { mapUserLocaleToShorthand } from 'i18n/mapUserLocaleToShorthand';

export default (date: number | Date, formattingString: string) =>
  format(date, formattingString, { locale: mapUserLocaleToShorthand() });
